var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jgile-carousel"},[_vm._t("default",null,{"next":_vm.next,"previous":_vm.previous,"goTo":_vm.goTo,"currentItem":_vm.currentItem,"itemCount":_vm.itemCount,"currentCount":_vm.currentCount,"items":_vm.items})],2)}
var staticRenderFns = []

export { render, staticRenderFns }